import { DownloadableItem, FavoriteItem } from '.';

export enum AuthenticatedActions {
    updateItemFavoriteState = 'UPDATE_ITEM_FAVORITE_STATE',
    downloadItem = 'DOWNLOAD_ITEM',
    creatorShareTrack = 'CREATOR_SHARE_TRACK',
    playGated = 'PLAY_GATED',
    addSamplesToCollection = 'ADD_SAMPLES_TO_COLLECTION',
}

export type AuthenticatedUserActionArgs = {
    [AuthenticatedActions.downloadItem]: [DownloadableItem];
    [AuthenticatedActions.updateItemFavoriteState]: [FavoriteItem];
    [AuthenticatedActions.creatorShareTrack]: [];
    [AuthenticatedActions.playGated]: [];
    [AuthenticatedActions.addSamplesToCollection]: [];
};

export type AuthenticatedUserAction<T extends AuthenticatedActions> = {
    type: T | '';
    args: AuthenticatedUserActionArgs[T];
} & {
    description?: string;
};

export type AnyAuthenticatedUserAction =
    AuthenticatedUserAction<AuthenticatedActions>;
